"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
function getCompletionStatusForLeafNode(completionCriteria, scaledProgressMeasure, actualSubmit) {
    switch (completionCriteria) {
        case entity_1.CompletionCriteria.MIN_PROGRESS_MEASURE: {
            if (scaledProgressMeasure <= 0) {
                return entity_1.CompletionStatus.NOT_ATTEMPTED;
            }
            else if (scaledProgressMeasure >= 1) {
                return entity_1.CompletionStatus.COMPLETE;
            }
            else {
                return entity_1.CompletionStatus.INCOMPLETE;
            }
        }
        case entity_1.CompletionCriteria.ACTUAL_SUBMIT: {
            if (!actualSubmit) {
                if (scaledProgressMeasure <= 0) {
                    return entity_1.CompletionStatus.NOT_ATTEMPTED;
                }
                else {
                    return entity_1.CompletionStatus.INCOMPLETE;
                }
            }
            return getCompletionStatusForLeafNode(entity_1.CompletionCriteria.MIN_PROGRESS_MEASURE, scaledProgressMeasure, actualSubmit);
        }
        default:
            console.info('Invalid completion criteria', completionCriteria);
    }
    return entity_1.CompletionStatus.NOT_ATTEMPTED;
}
exports.getCompletionStatusForLeafNode = getCompletionStatusForLeafNode;
//# sourceMappingURL=getCompletionStatusForLeafNode.js.map